import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import ProfileSettings from '../../components/dashboard/settings';
import { Payout } from '../../components/dashboard/saldo/payout';
import ShippingSettings from '../../components/dashboard/shippingSettings';
import axios from 'axios';

const SettingsPage = () => {

  const { user, setUser } = useContext(UserContext)
  const token = localStorage.getItem('token')

  return (
    <div className="h-full">
      <ProfileSettings />
    </div>
  )
}

export default SettingsPage